import React from 'react'
import Avatar from '@mui/material/Avatar'
import { NewsType, PressReleaseLight } from '@finance-lab/utils/types'
import { CalendarIcon, ChartLineIcon, MegaphoneIcon } from 'lucide-react'
import { Theme, useTheme } from '@mui/material/styles'

const NEWS_TYPE_LABEL: Partial<Record<NewsType, string>> = {
    [NewsType.PressRelease]: 'Pressmeddelande',
    [NewsType.Report]: 'Rapport',
    [NewsType.CompanyFinancialCalendar]: 'Finansiell kalender',
}

const getThemingForPressReleases = (pressRelease: Pick<PressReleaseLight, 'newsType'>, theme: Theme, size: number) => {
    let name = ''
    let icon = null
    let color: string | undefined = ''

    switch (pressRelease.newsType) {
        case NewsType.PressRelease:
            name = 'PR'
            icon = <MegaphoneIcon size={size - 10} />
            color = theme.palette.info[400]
            break
        case NewsType.CompanyFinancialCalendar:
            name = 'FK'
            icon = <CalendarIcon size={size - 10} />
            color = theme.palette.info[700]
            break
        case NewsType.Report:
            name = 'R'
            icon = <ChartLineIcon size={size - 10} />
            color = theme.palette.info[900]
            break
        default:
            name = 'PR'
    }

    return {
        color: color || '#000',
        name,
        icon,
    }
}

export const PressReleaseAvatar = ({
    pressRelease,
    size = 'medium',
}: {
    pressRelease: Pick<PressReleaseLight, 'newsType'>
    size?: 'small' | 'medium'
}) => {
    const width = {
        small: 24,
        medium: 32,
    }[size]
    const theme = useTheme()
    const avatarTheme = getThemingForPressReleases(pressRelease, theme, width)

    return (
        <Avatar
            key={avatarTheme.color}
            sx={{
                backgroundColor: avatarTheme.color,
                width: width,
                height: width,
            }}
            title={pressRelease.newsType ? NEWS_TYPE_LABEL[pressRelease.newsType] : ''}
        >
            {avatarTheme.icon ?? avatarTheme.name}
        </Avatar>
    )
}
